import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class Units {
  constructor() {
    log.info('[INFO] Initialize Units Module')

    this.axios = axios.create({
      baseURL: 'https://pncp.gov.br/api/',
      timeout: 10000,
    })

    this.axios.defaults.headers.common.Authorization = ''
  }

  fetchUnits() {
    const parameters = {
      params: {
        pagina: 1,
        tam_pagina: 10,
        q: '',
        tipos_documento: 'edital',
        ordenacao: '-data',
        status: 'recebendo_proposta',
      },
    }

    return new Promise((resolve, reject) => {
      this.axios
        .get('search/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to units from pncp')
          resolve(response.data.filters.unidades)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch units from pncp')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
